/**
 * Helpers for admin / ops "View As" portal preview.
 */

export function portalsOf(member) {
  return (member?.portals && member.portals.length ? member.portals : [member?.role]).filter(Boolean);
}

export function membersForPortal(members, portalId) {
  if (!portalId) return [];
  return (members || []).filter(m => m.active !== false && portalsOf(m).includes(portalId));
}

const PORTAL_DEFAULT_ROLE = {
  obc: 'obc_member',
  mp: 'mp',
  embedded: 'embedded',
  system: 'system',
  ops: 'ops',
  c_suite: 'c_suite',
  payload: 'payload',
  pe: 'pe',
  experimental: 'experimental',
  finance: 'finance',
  mentor: 'mentor',
};

const PORTAL_ADMIN_ROLE = {
  mp: 'mp_admin',
  embedded: 'em_admin',
  system: 'se_admin',
  ops: 'ops_admin',
  obc: 'obc_admin',
};

/** Portals that render a full department page (not the main-app OpsView). */
export const VIEW_AS_PORTAL_IDS = new Set([
  'obc', 'mp', 'embedded', 'system', 'ops', 'c_suite', 'payload', 'pe', 'experimental', 'finance', 'mentor',
]);

export function buildPreviewUser(member, portalId) {
  if (member) {
    return {
      uid: member.uid,
      name: member.name || member.email || 'Team Member',
      role: member.role,
      email: member.email || null,
      photoURL: member.photoURL || null,
    };
  }
  return {
    uid: `preview-${portalId}`,
    name: 'Team Member (Preview)',
    role: PORTAL_DEFAULT_ROLE[portalId] || portalId,
    email: null,
    photoURL: null,
  };
}

export function computePreviewIsAdmin(previewUser, portalId, readOnly = false) {
  if (readOnly) return false;
  const role = previewUser?.role || '';
  if (role === 'admin') return true;
  const adminRole = PORTAL_ADMIN_ROLE[portalId];
  if (adminRole && role === adminRole) return true;
  if (portalId === 'pe' && (role === 'ops_admin' || role === 'ops')) return true;
  if (portalId === 'experimental' && (role === 'admin' || role === 'ops')) return true;
  return false;
}
